const scrollParent = () =>
  typeof window !== 'undefined' ? window.document.body : null;

export default scrollParent;
